import React from 'react';
import { useAuth } from '../../context/AuthContext';

const ImpersonationBanner: React.FC = () => {
  const { impersonating, exitImpersonation } = useAuth();
  if (!impersonating) return null;

  return (
    <div className="fixed top-0 left-0 right-0 z-50 h-10 bg-red-600 text-white text-sm flex items-center justify-between px-5 shadow-lg">
      <span>
        <span className="font-semibold">Impersonating</span> {impersonating}
      </span>
      <button
        onClick={exitImpersonation}
        className="font-medium underline hover:no-underline transition-all"
      >
        Exit impersonation
      </button>
    </div>
  );
};

export default ImpersonationBanner;
